import {Component, OnDestroy, OnInit} from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AccountService } from '../../services/account.service';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { Router } from '@angular/router';
import { WindowService } from '../../services/window.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {ReSentActivationMailMsg} from '../../shareModel';
import {marker as TRANSLATE} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-odm-resend-activation-mail',
  templateUrl: './odm-resend-activation-mail.component.html',
  styleUrls: ['./odm-resend-activation-mail.component.css']
})
export class OdmResendActivationMailComponent implements OnInit, OnDestroy {
  recaptcha: any;
  captchaError = false;
  loginEmail: string;
  logoPath: string;
  hostName: string;
  Msg = '';
  displayResendDialog = false;
  private componentDestroyed = new Subject();
  constructor(
    private router: Router,
    private store: Store<fromStore.State>,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private windowService: WindowService,
    private translateService: TranslateService) {
    this.hostName = this.windowService.getHostName();
    this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res.length > 0) {
        const region = this.windowService.getLogoRegion(res);
        if (typeof region !== 'undefined' && region !== null) {
          this.logoPath = region.Note;
        }
        // const logoPath = res.find(i => i.Region.toLowerCase() === this.hostName.toLowerCase()).Note;
        // if (typeof logoPath !== 'undefined' && logoPath !== null) {
        //   this.logoPath = logoPath;
        // }
      }
    });
  }

  ngOnInit() {
    this.ngxService.start();
    this.recaptcha = (window as any).grecaptcha;
    setTimeout(() => {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('body-login');
      body.classList.remove('body-landing');
      body.classList.remove('mobile-toggle');
      this.ngxService.stop();
    },500)
    
  }

  sendEmail(e) {
    this.ngxService.start();
    this.captchaError = !this.recaptcha.getResponse();
    if (e.valid && this.recaptcha.getResponse()) {
      this.apiService.ReSendActivationMail(e.value.loginEmail).subscribe(res => {
        this.ngxService.stop();
        // 距離初次申請>7天,比對DB申請帳號資不存在
        setTimeout(() => {
          const code = parseInt(res.Message, 10);
          if (ReSentActivationMailMsg.hasOwnProperty(code)) {
            this.Msg = this.translateService.instant(ReSentActivationMailMsg[code], {Default: ReSentActivationMailMsg[code]});
          } else {
            this.Msg = this.translateService.instant(TRANSLATE('Update Fail'));
          }
          this.displayResendDialog = true;
        }, 500);
      });
    } else {
      this.ngxService.stop();
    }
  }

  closeDialog() {
    this.router.navigate(['/login']);
    this.displayResendDialog = false;
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }

}
